import { onBeforeMount, onUnmounted, watchEffect, nextTick } from 'vue'
import { useUserInfoStore } from '@/store'
import { storeToRefs } from 'pinia'
import { goNoAuthPage } from '@/utils'
import { PERFNOAPP } from '@/pages/noAuth/utils/index.js'
export function checkPerfPremision() {
  const userInfoStore = useUserInfoStore()
  let { isCanPreviewPerf } = storeToRefs(userInfoStore)
  if (isCanPreviewPerf.value === false) {
    goNoAuthPage(PERFNOAPP)
    return false
  }
  return true
}
export function useCheckPerf() {
  const userInfoStore = useUserInfoStore()
  let destory = null
  onBeforeMount(() => {
    destory = watchEffect(() => {
      let { isCanPreviewPerf } = storeToRefs(userInfoStore)
      if (isCanPreviewPerf.value === false) {
        goNoAuthPage(PERFNOAPP)
      }
    })
  })
  onUnmounted(() => {
    if (destory) {
      destory()
      destory = null
    }
  })
}
